<template>
  <v-col class="d-flex align-center justify-start">
    <v-text-field 
      v-model="searchText"
      class="mr-4"
      :label="label"
      :required="required"
      :style="{ maxWidth: maxWidth }"
      @keyup.enter="emitSearch"
    />
    <v-btn small color="primary" @click="emitSearch">
      Search
    </v-btn>
    <v-btn small @click="handleReset">
      Reset
    </v-btn>
  </v-col>
</template>

<script>
export default {
  name: "SearchField",
  props: {
    label: {
      type: String,
      default: 'Search'
    },
    required: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: String,
      default: '300px'
    }
  },
  data() {
    return {
      searchText: ''
    };
  },
  methods: {
    emitSearch() {
      this.$emit('search', this.searchText);
    },
    handleReset() {
      this.searchText = '';
      this.$emit('reset');
    }
  }
};
</script>
